import React, {Component} from 'react';
import {observer,inject} from "mobx-react";
import {toJS} from "mobx";
import AutosizeInput from 'react-input-autosize';
import Block from "./Block";
import Loading from "../Loading";
import {StoreContext} from "../../stores/contexts";



class UnlimitedFilter extends Component {
  static contextType = StoreContext;

  constructor(props) {
    super(props);
    this.state={
      input:''
    }
  }
  componentDidMount() {
    if(this.context.searchStore.blocks.length === 0) {

      // console.log(toJS(this.context.configStore.config.data.fields));
    }

  }
  render() {
    if(!this.context.configStore.config.inited) {
      return (
        <Loading />
      )
    }
    return (
      <div>
        <div className="hpadd5 ptop5 bg-w1 rad3 solid1 bo-w2 unlimitedFilterWrap">
          {this.context.searchStore.locked_blocks.map((item,index)=>{
            return (
              <Block key={index} item={item} index={index} locked={true} />
            )
          })}
          {this.context.searchStore.blocks.map((item,index)=>{
            return (
              <Block key={index} item={item} index={index} />
            )
          })}
          <span className="vpadd5 dib pc1 fs13 wsnw pointer unlimitedFilterAddBtn" onClick={()=>{ this.context.searchStore.blocks.push({code: '', compare: '', value: '', focus:0}); }}>
            <span className="textAddFilter">Добавить фильтр</span>
          </span>
        </div>
        <div className="fs13 vpadd5 w4 unlimitedFilterHelp">
          Для изменения способа сравнения, введите в начале строки: <span className="b1">=</span>, <span className="b1">&gt;</span>, <span className="b1">&lt;</span>, <span className="b1">&gt;=</span>, <span className="b1">&lt;=</span>, <span className="b1">!=</span>, <span className="b1">~</span><br/>
          Для добавления нового поля нажмите <span className="b1">\</span> или <span className="b1">/</span>. Для удаления фильтра нажмите <span className="b1">← backspace</span><br/>
          Для блокировки фильтра нажмите <span className="b1">Ctrl + Shift + L</span>
        </div>
      </div>
    )
  }
}

// export default inject("configStore","searchStore")(observer(UnlimitedFilter));
export default observer(UnlimitedFilter);